// DEPRECATED

export const GET_EXPERIENCES_FILTERS = 'GET_EXPERIENCES_FILTERS';

export function getExperiencesFilters(path = '', query, subrequest) {
  return {
    type: GET_EXPERIENCES_FILTERS,
    subrequest,
    request: {
      op: 'post',
      path: `${path}/@search-filters-experiences`,
      data: {
        query,
      },
    },
  };
}
